import { ConfigurationI } from '../../redux/types/configurations';

export const createConfigurationSignature = (configuration: ConfigurationI): string => {
  return JSON.stringify(configuration);
};
